export const METRICS = `
    totalContacts
    messagesSent
    messagesReceived
    optOuts
    linksClicked
    appointmentsBooked
`
